export default "__VITE_ASSET__YjWFKbVT__"